import { makePropertySelector } from 'store/utils';

const getPropertySelector = makePropertySelector('checkoutCurrency');

export const getUserSelectedCurrency = getPropertySelector(
  'userSelectedCurrency',
);
